<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <b-tabs content-class="mt-3">
                        <b-tab title="Thiết lập tham số hệ thống" active>
                            <b-form @submit.prevent="save">
                                <b-row v-for="(param, index) in parameters" :key="param.name">
                                    <b-col md="9">
                                        <template v-if="param.dataType != 0">
                                            <b-form-group :label="param.description"
                                                          :label-cols="7"
                                                          :horizontal="true"
                                                          label-align="left"
                                                          v-b-tooltip.focus>
                                                <template v-if="param.dataType == 2">
                                                    <b-form-input type="number"
                                                                  v-model="param.value">
                                                    </b-form-input>
                                                </template>
                                                <template v-if="param.dataType == 3">
                                                    <date-picker v-model="param.value" placeholder="dd/mm/yyyy"></date-picker>
                                                </template>
                                                <template v-if="param.dataType == 1">
                                                    <b-form-input type="text"
                                                                  v-model="param.value">
                                                    </b-form-input>
                                                </template>
                                                <template v-if="param.dataType == 4">
                                                    <b-form-checkbox v-model="param.value"></b-form-checkbox>
                                                </template>
                                            </b-form-group>
                                        </template>
                                        <template v-else>
                                            <h3> {{ param.description }} </h3>
                                            <hr />
                                        </template>
                                    </b-col>
                                </b-row>
                                <b-row v-if="isBTCUser">
                                    <b-col md="9">
                                        <b-form-group label=""
                                                      :label-cols="7">
                                            <b-button type="submit" variant="primary">Lưu</b-button>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-tab>
                        <b-tab title="Cấu hình link phần mềm" v-if="isAdmin">
                            <b-form @submit.prevent="saveSystemConfigUrl">
                                <b-grid :gridOptions="gridOptions"
                                        :items="configUrls"
                                        :showActions="true"
                                        gridName="Danh sách cấu hình link phần mềm"
                                        ref="configLinkTable">
                                    <template v-slot:actions v-if="authorize(['ManageUser'])">
                                        <b-button type="button" variant="primary" size="md" v-b-modal.modal-create-system-config-url>
                                            Thêm mới
                                        </b-button>
                                        <!--<b-button size="md" @click.stop="removeSelected" variant="danger">
                                            Xóa
                                        </b-button>-->
                                    </template>
                                    <template v-slot:cell(logo)="row">
                                        <b-img style="width:80px !important" :src="row.item.srcPreview" fluid-grow :alt="row.item.name"></b-img>
                                    </template>
                                    <template v-slot:cell(_actions)="row">
                                        <b-button-group>
                                            <template v-if="authorize(['ManageUser'])">
                                                <b-button size="sm" title="sửa" v-b-modal.modal-create-system-config-url @click="edit(row.item)" variant="info">
                                                    Sửa
                                                </b-button>
                                                <b-button size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                                    Xoá
                                                </b-button>
                                            </template>
                                        </b-button-group>
                                    </template>
                                </b-grid>
                            </b-form>

                            <b-modal :no-enforce-focus="true" id="modal-create-system-config-url"
                                     ref="modal"
                                     size="lg"
                                     :title="`${ configUrl.id ? 'Cập nhật' : 'Thêm mới'} cấu hình link phần mềm` "
                                     @hidden="resetModal"
                                     @ok="handleOk">
                                <form ref="form" @submit.stop.prevent="submit">
                                    <b-form-group label="Tên đường dẫn:"
                                                  label-for="name"
                                                  label-cols-md="4"
                                                  label-align="left"
                                                  :horizontal="true">
                                        <b-form-input v-model="$v.configUrl.name.$model" id="name" class="no-padding"
                                                      :state="$v.configUrl.name.$dirty? !$v.configUrl.name.$error : null"></b-form-input>
                                        <b-form-invalid-feedback>
                                            Vui lòng nhập tên đường dẫn
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group label="Đường link phần mềm:"
                                                  label-for="link"
                                                  label-cols-md="4"
                                                  label-align="left"
                                                  :horizontal="true">
                                        <b-form-input id="link" v-model="$v.configUrl.link.$model" class="no-padding"
                                                      :state="$v.configUrl.link.$dirty? !$v.configUrl.link.$error : null"></b-form-input>
                                        <b-form-invalid-feedback>
                                            Vui lòng nhập đường link phần mềm
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group label="Logo:"
                                                  label-cols-md="4"
                                                  label-align="left"
                                                  :horizontal="true">
                                        <b-form-file v-model="configUrl.logoFile"
                                                     class="no-padding"
                                                     accept=".png,.jpg"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                        <label class="control-label" v-if="configUrl.logoFile == null">{{configUrl.logoFileName}}</label>
                                    </b-form-group>
                                </form>
                                <template #modal-footer="{ ok, cancel, hide }">
                                    <b-button type="button" variant="primary" @click="ok()">
                                        Lưu
                                    </b-button>
                                    <b-button type="button" variant="secondary" @click="cancel()">
                                        Hủy
                                    </b-button>
                                </template>
                            </b-modal>
                        </b-tab>

                        <b-tab title="Cấu hình hiển thị trang chủ" v-if="isAdmin">
                            <h3>Cấu hình hiển thị trang chủ</h3>
                            <hr />
                            <b-form @submit.prevent="saveConfigHome">
                                <DocumentEditor v-model="configHomePage.value" />
                                <br />
                                <b-row v-if="isAdmin">
                                    <b-col md="9">
                                        <b-form-group label=""
                                                      :label-cols="7">
                                            <b-button type="submit" variant="primary">Lưu</b-button>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    import { validationMixin } from 'vuelidate'
    import { required, requiredIf, helpers, minValue } from 'vuelidate/lib/validators'

    const formatPattern = helpers.regex('formatPattern', /^((((\d+,)+\d+|(\d+(\/|-|#)\d+)|\d+L?|\*(\/\d+)?|L(-\d+)?|\?|[A-Z]{3}(-[A-Z]{3})?) ?){5})$/)

    //const formatPattern1 = helpers.regex('formatPattern1', /^(\*|(1?[0-9]|2[0-3])(-(1?[0-9]|2[0-3]))?)(\/[1-9][0-9]*)?(,(\*|(1?[0-9]|2[0-3])(-(1?[0-9]|2[0-3]))?)(\/[1-9][0-9]*)?)*$/)

    export default {
        name: 'CreateSytemParameter',
        mixins: [mixins],
        data() {
            return {
                editing: false,
                parameters: [],
                configUrls: [],
                gridOptions: {
                    fields: [
                        { key: 'name', label: 'Tên đường dẫn (Tên link)', sortable: false },
                        { key: 'link', label: 'Đường dẫn (Link)', sortable: false },
                        { key: 'logo', label: 'Biểu tượng (Logo)', sortable: false }
                    ],
                    sortBy: 'name'
                },
                configUrl: {
                    logoFile: null,
                    name: null,
                    link: null,
                    logoFileContent: null,
                },
                configHomePage: {
                    value: null
                },
            }
        },
        computed: {
        },
        created() {
            this.loadSytemParamter();
            this.loadSystemConfigUrl();
        },
        validations: {
            configUrl: {
                name: { required },
                link: { required },
            }
        },
        watch: {
        },
        methods: {
            save() {
                var vm = this;
                this.$services.put('system-parameters/systems', this.parameters).done((response) => {
                    vm.$toastr.s('Cập nhật tham số hệ thống thành công');
                });
            },
            loadSytemParamter() {
                var vm = this;
                this.$services.get('system-parameters/systems').done((response) => {
                    var homePage = response.find(x => x.name === 'HOME_PAGE');
                    if (homePage) {
                        vm.configHomePage = homePage;
                    }
                    vm.parameters = [...response.filter((x) => {
                        return x.name !== 'HOME_PAGE'
                    })];
                });
            },
            loadSystemConfigUrl() {
                var vm = this;
                this.$services.get('system-parameters/systems-config-url').done((response) => {
                    vm.configUrls = response;
                    vm.configUrls.forEach((item) => {
                        item.srcPreview = "data:image/png;base64," + item.logoFileContent;
                    })
                });
            },
            resetModal() {
                this.configUrl.id = 0;
                this.configUrl.name = null;
                this.configUrl.link = null;
                this.configUrl.logoFile = null;
                this.$v.$reset();
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault();
                this.submit();
            },
            cancel(bvModalEvt) {
                this.resetModal();
                this.$bvModal.hide('modal-create-system-config-url');
            },
            submit() {
                this.$v.$touch();
                var vm = this;
                if (!this.$v.configUrl.$invalid) {
                    this.$services.upload('system-parameters/systems-config-url', vm.getFormData(this.configUrl)).done((id) => {
                        vm.$toastr.s('Cập nhật cấu hình link phần mềm thành công');
                        vm.cancel();
                        vm.loadSystemConfigUrl();
                    });
                }
            },
            edit(data) {
                this.configUrl.id = data.id;
                this.configUrl.name = data.name;
                this.configUrl.link = data.link;
                this.configUrl.logoFileName = data.logoFileName;
            },
            remove(item) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa bản ghi này?')) {
                    this.$services.delete(`system-parameters/systems-config-url/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa cấu hình link phần mềm thành công');
                        this.configUrls.remove(item);
                    });
                }
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.configLinkTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các bản ghi này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`system-parameters/systems-config-url?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các cấu hình link phần mềm thành công');
                            vm.loadSystemConfigUrl();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn cấu hình link phần mềm cần xóa');
                }
            },
            getFormData(object) {
                const formData = new FormData();
                Object.keys(object).forEach(key => formData.append(key, object[key]));
                return formData;
            },
            saveConfigHome() {
                var vm = this;
                this.$services.put(`system-parameters/config-home-pages`, this.configHomePage).done((response) => {
                    vm.$toastr.s('Cập nhật trang trang chủ thành công');
                });
            }
        }
    }

</script>
<style scoped>
</style>
<style>
    /*  .ck-editor__editable {
        min-height: 500px;
    }*/
    .ck-editor .ck-editor__main .ck-content {
        min-height: 200px;
    }

    .ck-editor__editable_inline {
        min-height: 200px;
    }
</style>

